var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-row",
    { attrs: { type: "flex", justify: "space-between" } },
    [
      _c("el-col", { attrs: { span: 16 } }, [
        _c("p", { staticClass: "title" }, [
          _c("strong", [_vm._v(_vm._s(_vm.label) + " List")]),
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "se-list",
            attrs: { "element-loading-text": "Loading..." },
          },
          [
            _c("div", { staticClass: "se-item header" }, [
              _c("div", { staticClass: "se-info-item name" }, [_vm._v("Name")]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "role",
                      rawName: "v-role",
                      value: [1, 2, 3, 13],
                      expression: "[1,2,3,13]",
                    },
                  ],
                  staticClass: "se-info-item name",
                },
                [_vm._v("Type")]
              ),
              _c("div", { staticClass: "se-info-item city" }, [
                _vm._v("Province"),
              ]),
              _c("div", { staticClass: "se-info-item city" }, [_vm._v("City")]),
              _c("div", { staticClass: "se-info-item hospital" }, [
                _vm._v("Hospital"),
              ]),
              _c("div", { staticClass: "se-info-item department" }, [
                _vm._v("Department"),
              ]),
            ]),
            _vm.list.length === 0
              ? _c("div", { staticClass: "empty" }, [
                  _c("p", [_vm._v("No Data")]),
                ])
              : _vm._l(_vm.list, function (item) {
                  return _c("div", { key: item.SEID, staticClass: "se-item" }, [
                    _c("div", { staticClass: "se-info-item name" }, [
                      _vm._v(_vm._s(item.Name)),
                    ]),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "role",
                            rawName: "v-role",
                            value: [1, 2, 3, 13],
                            expression: "[1,2,3,13]",
                          },
                        ],
                        staticClass: "se-info-item name",
                      },
                      [_vm._v(_vm._s(item.Type))]
                    ),
                    _c("div", { staticClass: "se-info-item city" }, [
                      _vm._v(_vm._s(item.Province)),
                    ]),
                    _c("div", { staticClass: "se-info-item city" }, [
                      _vm._v(_vm._s(item.City)),
                    ]),
                    _c("div", { staticClass: "se-info-item hospital" }, [
                      _vm._v(_vm._s(item.Hospital)),
                    ]),
                    _c("div", { staticClass: "se-info-item department" }, [
                      _vm._v(_vm._s(item.Department)),
                    ]),
                  ])
                }),
          ],
          2
        ),
      ]),
      _c("el-col", { attrs: { span: 6 } }, [
        _c("p", { staticClass: "title" }, [
          _c("strong", [_vm._v("Request Info")]),
        ]),
        _c("p", {
          staticClass: "request-info",
          domProps: { innerHTML: _vm._s(_vm.requestInfo) },
        }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }